// removed by extract-text-webpack-plugin
module.exports = {"customPanel":"customPanel___A5ByN","clarify":"clarify___1Vz9i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Summary/Summary.module.scss
// module id = 2241
// module chunks = 0